<template>
  <div class="bindingProductListBox">
    <div
      class="mask"
      @touchmove.stop.prevent="touchstartReturn"
      :style="{
        width: this.$store.state.PCFlag ? '11.04rem' : '',
        margin: this.$store.state.PCFlag ? '0 auto' : '',
      }"
      v-show="mask"
    >
      <mt-picker
        :slots="myAddressSlots"
        @change="onMyAddressChange"
        :style="{
          width: this.$store.state.PCFlag ? '11.04rem' : '',
          margin: this.$store.state.PCFlag ? '0 auto' : '',
        }"
      ></mt-picker>
    </div>
    <div class="addProductBtnBox">
      <div class="selected" v-show="selectedList.length > 0">
        <div class="selectedList">
          <div class="item" v-for="(item, index) in selectedList" :key="index">
            <div class="txt">{{ item.name }}</div>
            <div class="del" @click.stop="deleteSelectedItem(index)">
              <img src="../../assets/images/updataFile/product-del-icon.png" />
            </div>
          </div>
        </div>
      </div>
      <div
        class="addProductBtn2"
        @click="goSearchProduct"
        v-if="selectedList.length == 0"
      >
        <div class="addProductBtn2Content">
          <img src="../../assets/images/updataFile/add-ccc-icon.png" />
          添加检测项目
        </div>
      </div>
      <div class="addProductBtn" v-else @click="goSearchProduct">
        <img src="../../assets/images/updataFile/add-icon.png" />
        添加
      </div>
    </div>

    <div class="userInfo-list">
      <div class="item">
        <div class="key">受检人姓名：</div>
        <div class="value">
          <input
            type="text"
            @blur="saveOfflineEntry"
            v-model="fillInInfo.examineeName"
            placeholder="请输入受检人姓名"
          />
        </div>
      </div>
      <div class="item">
        <div class="key">受检人邮箱：</div>
        <div class="value">
          <input
            type="emali"
            @blur="saveOfflineEntry"
            placeholder="请输入邮箱用于接收报告"
            v-model="fillInInfo.email"
          />
        </div>
      </div>
      <div class="item">
        <div class="key">受检人手机号：</div>
        <div class="value">
          <input
            type="tel"
            @blur="saveOfflineEntry"
            placeholder="请输入手机号做用户唯一标识"
            v-model="fillInInfo.mobile"
          />
        </div>
      </div>
      <div class="item">
        <div class="key">年龄：</div>
        <div class="value">
          <input
            type="tel"
            @blur="saveOfflineEntry"
            placeholder="请输入受检人年龄"
            v-model="fillInInfo.age"
          />
        </div>
      </div>
      <div class="item sex">
        <div class="key">性别：</div>
        <div class="value">
          <div
            @click="sexToggle('男')"
            :class="['man', fillInInfo.examineeSex == '男' ? 'active' : '']"
          >
            男
          </div>
          <div
            @click="sexToggle('女')"
            :class="['woman', fillInInfo.examineeSex == '女' ? 'active' : '']"
          >
            女
          </div>
        </div>
      </div>
      <div
        class="item"
        @click="toAddress('channelName', fillInInfo.channelName)"
      >
        <div class="key">所属渠道：</div>
        <div class="value radioBox">
          <div style="color: #999" v-if="!fillInInfo.channelName">
            请选择所属渠道
          </div>
          <div v-else>{{ fillInInfo.channelName }}</div>
        </div>
      </div>
      <div class="item" @click="selectData('samplingTime')">
        <!-- samplingTime -->
        <div class="key">采样时间：</div>
        <div class="value">
          <div v-if="!fillInInfo.samplingTime" style="color: #999">
            请选择采样时间
          </div>
          <div v-else>{{ fillInInfo.samplingTime }}</div>
        </div>
      </div>
      <div class="item" @click="selectData('inspectionTime')">
        <!-- inspectionTime -->
        <div class="key">送检时间：</div>
        <div class="value">
          <div v-if="!fillInInfo.inspectionTime" style="color: #999">
            请选择送检时间
          </div>
          <div v-else>{{ fillInInfo.inspectionTime }}</div>
        </div>
      </div>
    </div>
    <div
      class="saveDetectBoxUserData"
      @click="saveDetectBoxUserData"
      v-show="btnFlag"
      :style="{
        width: this.$store.state.PCFlag ? '11.04rem' : '',
        margin: '0 auto',
      }"
    >
      <div class="txt">确认并提交</div>
    </div>
  </div>
</template>

<script>
import { Picker } from "mint-ui";
export default {
  components: { "mt-picker": Picker },
  data() {
    return {
      selectedList: [],
      barCode: "",
      total: "4",
      fillInInfo: {
        examineeSex: "男",
      },
      name: "",
      productIds: [],
      btnFlag: true,
      allChannelList: [],
      mask: false,
      addressValue: "",
      addressName: "",
      myAddressSlots: [
        {
          flex: 1,
          defaultIndex: 0,
          values: [],
          className: "slot1",
          textAlign: "center",
        },
      ],
    };
  },
  created() {
    this.barCode = this.$route.query.barCode;
    if (sessionStorage.getItem("productIds")) {
      this.productIds = JSON.parse(sessionStorage.getItem("productIds"));
      this.selectedList = JSON.parse(sessionStorage.getItem("selectedList"));
    }
    if (localStorage.getItem("offlineEntry"))
      this.fillInInfo = JSON.parse(localStorage.getItem("offlineEntry"));
    this.$http.get(`/channel/getList`).then((res) => {
      if (res.data.code == 200) {
        let list = res.data.data;
        let values = [];
        list.forEach((item) => {
          values.push(item.name);
        });
        this.allChannelList = list;
        this.myAddressSlots[0].values = values;
      }
    });
  },
  methods: {
    /**
     * 切换性别
     */
    sexToggle(examineeSex) {
      let data = this.fillInInfo;
      if (examineeSex != data.examineeSex) {
        this.$set(this.fillInInfo, "examineeSex", examineeSex);
        this.inputBlur();
      }
    },
    saveOfflineEntry() {
      localStorage.setItem("offlineEntry", JSON.stringify(this.fillInInfo));
    },
    /**
     * 删除已选择产品
     */
    deleteSelectedItem(index, flag) {
      this.selectedList.splice(index, 1);
      this.productIds.splice(index, 1);
    },
    goSearchProduct() {
      sessionStorage.setItem("productIds", JSON.stringify(this.productIds));
      sessionStorage.setItem("selectedList", JSON.stringify(this.selectedList));
      this.$router.push({
        name: "searchProduct",
        query: {
          barCode: this.barCode,
        },
      });
    },
    /**
     *出现加载中的时候不让滚动
     */
    touchstartReturn() {
      return;
    },
    // 点击弹出三级联动
    toAddress(name, address) {
      if (this.addressName != name) {
        this.addressName = name;
        if (address) {
          this.myAddressSlots[0].defaultIndex =
            this.myAddressSlots[0].values.indexOf(address);
        }
      }
      this.mask = true;
    },

    onMyAddressChange(picker, values) {
      if (values[0]) {
        this.addressValue = values[0];
      }
    },
    /**
     * 选择时间
     */
    selectData(name) {
      let year = new Date().getFullYear();
      let Month = new Date().getMonth() + 1;
      let date = new Date().getDate();
      // 出生日期
      let startTime = year - 100 + "-" + Month + "-" + date;
      let endTime = year + "-" + Month + "-" + date;
      let date2 = endTime;
      this.$picker.show({
        type: "datePicker",
        endTime: endTime, //截至时间
        startTime: startTime, //开始时间
        date: date2,
        onOk: (e) => {
          e = e.replace(/\-/g, "/");
          let n = new Date(e).getFullYear();
          let y = new Date(e).getMonth() + 1;
          let r = new Date(e).getDate();
          if (y < 10) y = "0" + y;
          if (r < 10) r = "0" + r;
          this.$set(this.fillInInfo, name, n + "-" + y + "-" + r);
          this.saveOfflineEntry();
        },
      });
    },
    saveDetectBoxUserData() {
      let data = this.fillInInfo;
      if (this.$store.state.closureFlag) {
        this.$store.state.closureFlag = false;
        let emailRes =
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (this.productIds.length == 0) this.$toots("请选择产品");
        else if (!data.examineeName) this.$toots("请输入受检人姓名");
        else if (!data.email) this.$toots("请输入邮箱");
        else if (!emailRes.test(data.email)) this.$toots("请确认邮箱是否正确");
        else if (!data.mobile) this.$toots("请输入手机号");
        else if (!data.channelName) this.$toots("请选择渠道");
        else if (!data.samplingTime) this.$toots("请选择采样时间");
        else if (!data.inspectionTime) this.$toots("请选择送检时间");
        else {
          data.barCode = this.barCode;
          data.doctorsId = JSON.parse(
            localStorage.getItem("systemUserInfo")
          ).id;
          data.productIds = this.productIds.join(",");
          // data.doctorsId = "1293838473986252801";
          let list = this.allChannelList;
          for (let i = 0; i < list.length; i++) {
            if (list[i].name == data.channelName) {
              data.channelId = list[i].id;
              break;
            }
          }
          this.$store.state.closureFlag = true;
          this.$loading("提交中");
          this.$http
            .post(`/detectBox/saveDetectBoxUserData`, data, { qs: "no" })
            .then((res) => {
              if (res.data.code == 200) {
                sessionStorage.removeItem("selectedList");
                sessionStorage.removeItem("productIds");
                localStorage.removeItem("offlineEntry");
                this.$tootsSuccess("保存成功");
                setTimeout(() => {
                  this.$router.replace({
                    name: "sweepCodeBinding",
                    query: {
                      type: 2,
                    },
                  });
                }, 1500);
              } else this.$toots(res.data.msg);
            })
            .catch((err) => {
              this.$toots("系统正在升级，请稍后");
            });
        }
      }
    },
  },
  mounted() {
    let winh = document.body.clientHeight; // 取窗口可视范围的高度
    window.addEventListener("resize", () => {
      if (document.body.clientHeight < winh) {
        this.btnFlag = false; //隐藏按钮
      } else {
        this.btnFlag = true; //显示按钮
      }
    });
    var para = document.createElement("div");
    var element = document.querySelector(".picker");
    element.appendChild(para);
    para.setAttribute("class", "btn");
    element.children[1].innerHTML = `<div class="no">取消</div><div class="yes">确定</div>`;
    element.children[1].children[1].onclick = () => {
      this.mask = false;
      if (!this.addressValue)
        this.addressValue = this.myAddressSlots[0].values[0];
      this.$set(this.fillInInfo, this.addressName, this.addressValue);
      this.saveOfflineEntry();
    };
    element.children[1].children[0].onclick = () => {
      this.mask = false;
    };
  },
};
</script>

<style lang='less' scoped>
.bindingProductListBox {
  background-color: #f0f0f0;
  padding-bottom: 100px;
  .addProductBtnBox {
    background-color: #fff;
    padding: 30px;
    .addProductBtn {
      text-align: center;
      background-color: #1968a8;
      border-radius: 76px;
      height: 76px;
      line-height: 76px;
      color: #fff;
      width: 200px;
      margin: 0 auto;
      font-size: 30px;
      img {
        width: 32px;
        vertical-align: middle;
        margin-bottom: 2px;
        margin-right: 10px;
      }
    }
    .addProductBtn2 {
      background-color: #f8f8f8;
      height: 250px;
      border-radius: 10px;
      border: 1px dashed #ccc;
      position: relative;
      text-align: center;
      font-size: 30px;
      .addProductBtn2Content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 50px;
        img {
          width: 64px;
          height: 64px;
          display: block;
          margin: 0 auto;
        }
      }
    }
  }
}
/* 已选择产品 */
.selectedList {
  padding-bottom: 30px;
  padding-left: 30px;
  padding-right: 30px;
  .item:last-child {
    border-bottom: none;
  }
  .item {
    border-bottom: 1px solid #eee;
    line-height: 40px;
    font-size: 30px;
    min-height: 110px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .txt {
      flex: 1;
      padding-top: 20px;
      padding-bottom: 20px;
    }
    .del {
      img {
        width: 32px;
      }
    }
  }
}
.saveDetectBoxUserData {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  padding-bottom: env(safe-area-inset-bottom);
  padding-bottom: constant(safe-area-inset-bottom);
  .txt {
    background-color: #1968a8;
    font-size: 32px;
    height: 98px;
    line-height: 98px;
    color: #fff;
    text-align: center;
  }
}

.userInfo-list {
  background-color: #fff;
  padding-left: 30px;
  padding-right: 30px;
  border-radius: 6px;
  margin-top: 20px;
  // 选择性别单独样式
  .item.sex {
    .value {
      display: flex;
      align-items: center;
      position: relative;
      > div:first-child {
        margin-right: 30px;
      }
      > div {
        width: 160px;
        height: 60px;
        line-height: 60px;
        font-size: 28px;
        text-align: center;
        border-radius: 60px;
        border: 2px solid #e6e6e6;
      }
    }
    .active {
      background-color: #1968a8;
      color: #fff;
      border: none;
    }
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 118px;
    line-height: 118px;
    border-bottom: 1px solid #ebebeb;
    font-size: 28px;
    .key {
      width: 230px;
      font-size: 30px;
      color: #222;
    }
    .value {
      flex: 1;
      position: relative;
      input {
        font-size: 30px;
        color: #222;
        opacity: 1;
        width: 100%;
      }
      input::placeholder {
        font-size: 30px;
        color: #ccc;
      }
    }
    .fileBox {
      margin-bottom: 30px;
      height: 340px;
      border: 1px dashed #bbb;
      border-radius: 10px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      position: relative;
      .fileSuccessImg {
        height: 100%;
        border-radius: 10px;
        overflow: hidden;
        img {
          border-radius: 10px;
          // width:100%;
          height: 100%;
          display: block;
          margin: 0 auto;
        }
      }
      .shut {
        position: absolute;
        top: -30px;
        right: -30px;
        width: 60px;
        height: 60px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      input {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      .none {
        flex: 1;
      }
      .fileTxt {
        line-height: 40px;
        text-align: center;
        color: #b8b8b8;
        font-size: 24px;
        img {
          width: 48px;
          height: 42px;
        }
      }
    }
  }
}
</style>
